import { GlobalState } from '@leverege/ui-redux';
import OverridesReducer from "./OverridesReducer.js";
const PATH_PREFIX = 'ui/dataViewers/overrides';

/**
 * Class used for loading, unloading, getting, and setting resources for a specific user.
 */
class UserResourcesStore {
  constructor() {
    this.api = null;
    this.userId = null;
  }
  async load(userId) {
    this.api = window.MoltenCli.molten.get('api');
    this.userId = userId;
    const {
      items: resources
    } = await this.api.user(userId).resources().list(PATH_PREFIX, {
      limit: 1000
    });
    const flatResources = resources.reduce((prev, resource) => {
      return {
        ...prev,
        [resource.path.replace(`${PATH_PREFIX}/`, '')]: resource.data
      };
    }, {});
    GlobalState.dispatch({
      type: 'molten.dataViewers.SetAllOverrides',
      values: flatResources
    });
  }
  unload() {
    this.api = null;
    this.userId = null;
  }
  get(path) {
    return OverridesReducer.get(GlobalState.get(), path);
  }
  async set(path, id, key, value) {
    const ovs = OverridesReducer.get(GlobalState.get(), path, id);
    const exists = ovs != null;
    if (exists) {
      await this.api.user(this.userId).resource(`${PATH_PREFIX}/${path}/${id}`).update([{
        op: 'replace',
        path: `data/${key}`,
        value
      }]);
    } else {
      await this.api.user(this.userId).resource(`${PATH_PREFIX}/${path}/${id}`).create({
        [key]: value
      });
    }
  }
}
export default new UserResourcesStore();